
export class SkechersPoOrderFilter {
    poNumber?: string;
    // externalRefNo?:string
    poStyle?: string;
    deliveryAddress?: any
    exFactoryDate?: any
    color?: string
    size?: string
    quantity?: any


    constructor(
        poNumber?: string,
        poStyle?: string,
        deliveryAddress?: any,
        exFactoryDate?: any,
        color?: string,
        size?: string,
        quantity?: any,
    ) {
        this.poNumber = poNumber;
        this.poStyle = poStyle
        this.deliveryAddress = deliveryAddress
        this.exFactoryDate = exFactoryDate
        this.color = color
        this.size = size
        this.quantity = quantity
    }
}